import { useEffect, useState } from "react";

import Badge from "react-bootstrap/Badge";

import { useIsFirstRender } from "/src/components/hooks/first_render.js";

const PillFilter = ({ placeholder="Select", isMulti, onChange, options=[], value }) => {

  const isFirstRender = useIsFirstRender();
  const [uncontrolledValue, setUncontrolledValue] = useState(value);

  useEffect(() => {
    if (isFirstRender) {
      return;
    }
    if (typeof onChange === "function") {
      onChange(uncontrolledValue);
    }
  }, [uncontrolledValue]);

  useEffect(() => {
    setUncontrolledValue(value);
  }, [value]);

  const onUpdate = (option) => {
    let newValue = option;
    if (isMulti) {
      newValue = [...(uncontrolledValue || [])];
      if (isSelected(option)) {
        let deleteIndex = newValue.findIndex(item => item.value === option.value);
        newValue.splice(deleteIndex, 1);
      }
      else {
        newValue.push(option);
      }
    }
    setUncontrolledValue(newValue);
  }

  const getValue = () => {
    let finalValue = value;
    if (typeof finalValue === "undefined") {
      finalValue = uncontrolledValue;
    }
    return finalValue;
  }

  const isSelected = (option) => {
    let finalValue = getValue();
    if (finalValue) {
      finalValue = Array.isArray(finalValue) ? finalValue : [finalValue];
      return finalValue.find(item => item.value === option.value);
    }
  }

  const renderOption = (option) => {
    let classNames = ["cursor-pointer p-2"].concat(isSelected(option) ? [""] : ["text-dark"]);
    let bg = isSelected(option) ? "dark" : "light";
    return (
      <Badge
        pill
        key={option.value}
        bg={bg}
        className={classNames.join(" ")}
        onClick={() => onUpdate(option)}
      >
        <div className={option.className}>
          {option.label}
        </div>
      </Badge>
    );
  }

  const renderOptions = () => {
    return options.map(item => renderOption(item));
  }

  return (
    <div className="d-flex flex-row flex-nowrap overflow-scroll scrollbar-d-none gap-2">
      {renderOptions()}
    </div>
  );

}

export default PillFilter;
